exports = module.exports = require("../../../../node_modules/react-scripts/node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, "a.item {\n    opacity: 1 !important;\n}", ""]);

// exports
